import { PageWrapper } from '@approvalmax/ui/src/components';
import { FC, memo, PropsWithChildren } from 'react';

import { Navigation } from './resources/components';

export const Layout: FC<PropsWithChildren> = memo((props) => {
    const { children } = props;

    return (
        <PageWrapper>
            <PageWrapper.Toolbar spacingTop={0} spacingBottom={0} fullWidth bordered>
                <Navigation />
            </PageWrapper.Toolbar>

            <PageWrapper.Content spacingTop={24}>{children}</PageWrapper.Content>
        </PageWrapper>
    );
});

Layout.displayName = 'Layout';
